import { graphHooks } from '@tunasong/graph-lib/react'
import { profilesApi } from '@tunasong/redux'
import type { EntityType, EventCommands } from '@tunasong/schemas'
import invariant from 'tiny-invariant'

// Map of EntityType,
type EventCommandsByTypeConfig = Partial<Record<EntityType, EventCommands>>

export const useProfileCommands = (type?: EntityType) => {
  const { profile } = graphHooks.useProfile()
  const [updateProfile] = profilesApi.useUpdateProfileMutation()

  const config = profile?.config

  const eventCommandsByType = (config?.eventCommandsByType ?? {}) as EventCommandsByTypeConfig
  const eventCommands = type ? (eventCommandsByType[type] ?? {}) : {}

  const onChange = (newCommands: EventCommands) => {
    invariant(type && profile)
    const newConfig = {
      ...eventCommandsByType,
      [type]: newCommands,
    }
    updateProfile({
      id: profile.id,
      profile: {
        config: {
          ...config,
          eventCommandsByType: newConfig,
        },
      },
    })
  }

  return { eventCommands, onChange }
}
